// printNode.js
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const PrintNode = ({ id, data }) => {
    return (
        <BaseNode
            id={id}
            data={data}
            title="Print"
            handles={[
                { type: 'target', position: Position.Left, id: `${id}-input` }
            ]}
        >
            <div className="text-sm text-gray-500">
                <span>Log to console</span>
            </div>
        </BaseNode>
    );
};
